import { Stack, Text } from "@chakra-ui/react";
import { useTextVariants } from "@/theme/components/useSectionHeading";
import virtuzzo from "public/privateCloud/virtuozzo-paas.jpg";

type DescCompProps = {
  description: string[];
};

const DescComp = (props: DescCompProps) => {
  const TextVariant = useTextVariants();
  const { description } = props;
  return (
    <Stack spacing={2}>
      {description.map((desc, index) => (
        <Text key={index} variant={TextVariant} color="text.100">
          {desc}
        </Text>
      ))}
    </Stack>
  );
};

export const INTRO_CONSTANTS = {
  heading: "Virtuozzo Platform as a Service (PaaS) ",
  description: (
    <DescComp
      description={[
        "At OneMind, we bring the power of Virtuozzo PaaS into a fully managed, virtual-first experience—so teams can build, deploy, and scale applications without touching infrastructure. The platform’s built-in elasticity and automation streamline every stage of the application lifecycle, enabling faster delivery and smoother operations across any cloud environment.",
        "By embedding Virtuozzo’s capabilities into our cloud-native architecture, OneMind removes complexity from DevOps workflows. Resources scale automatically, environments stay optimized, and your teams stay focused on building—not managing. It’s application deployment, redefined: fully managed, infinitely scalable, and built for speed.",
        "With OneMind, you don’t just use Virtuozzo—you unlock its full potential, without the overhead.",
      ]}
    />
  ),
  points: [
    "Hyperconverged infrastructure for IaaS workloads ",
    "PaaS for automated application scaling",
    "Multi-cloudd & hybrid cloud-ready ",
  ],
  image: virtuzzo,
};
